import { Params } from '@angular/router';
import { createAction, props } from "@ngrx/store";
import { DetalleStock, Filter, Maestros, Material, Stock, UnidadMedida } from "../models";

export const loadMaestrosMaterial = createAction(
  '[MAIN] carga de datos maestros de los materiales',
  props<Maestros>()
)

export const loadMaestrosMaterialRequest = createAction(
  '[MAIN] peticion de carga de datos maestros'
)

export const loadStockRequest = createAction(
  '[SEARCH] petición de carga de stock con los filtros',
  props<{ filters: Filter[], limit: number, offset: number }>()
)

export const loadStock = createAction(
  '[SEARCH] carga una lista de materiales del stock al estado',
  props<{ stock: Stock[] }>()
)

export const loadResultsCountRequest = createAction(
  '[SEARCH] peticion para actualizar cuenta de resultados',
  props<{ filters: Filter[] }>()
)

export const setResultsCount = createAction(
  '[SEARCH] actualiza el numero de resultados en el state',
  props<{ count: number }>()
)

export const selectStockItem = createAction(
  '[DETAIL] selecciona un item del stock para ver cargar los detalles',
  props<{ item: Stock }>()
)

export const loadDetails = createAction(
  '[DETAIL] carga los datos de detalle',
  props<{ detalles: DetalleStock[] }>()
)

export const loadDetailsRequest = createAction(
  '[DETAIL] peticion de carga de datos de detalles',
  props<{ params: string[] }>()
)

export const deserializeDetailsParams = createAction(
  '[DETAIL] descompone los parametros de la url de detalle',
  props<{ query: Params }>()
)

export const loadMaterialesSimilaresRequest = createAction(
  '[DETAIL] peticion de carga de datos de materiales similares',
  props<{ param: string }>()
)

export const loadMaterialesSimilares = createAction(
  '[DETAIL] carga materiales similares al estado',
  props<{ materiales: Material[] }>()
)

export const loadMaterialBookmatchRequest = createAction(
  '[BOOKMATCH] peticion de carga de material de bookmatch',
  props<{ material: Material['CODIGO'] }>()
)

export const loadMaterialBookmatch = createAction(
  '[BOOKMATCH] carga material para visualizar en bookmatch',
  props<{ material: Material }>()
)

export const changeUnidadMedida = createAction(
  '[UNIDAD MEDIDA] cambia unidad de medida',
  props<{ unidad: UnidadMedida }>()
)
